const schema = import.meta.env.PROD ? 'https' : 'http';

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;
export const PEQUITY_BASE_URL = import.meta.env.VITE_PEQUITY_BASE_URL ?? 'localhost:8000';
export const PEQUITY_API_URL = `${schema}://${import.meta.env.VITE_PEQUITY_BASE_URL}/api` as string;
export const PEQUITY_SOCKET_PROTOCOL = import.meta.env.PROD ? 'wss' : 'ws';
